import Vue from 'vue'
import VueRouter from 'vue-router'
// ルート用のコンポーネントを読み込む
import Top from '@/views/Top'
import Works from '@/views/Works'
import Project from '@/views/Project'
import Profile from '@/views/Profile'
import Contact from '@/views/Contact'
import Hiyamizu from '@/views/Hiyamizu'
import Aozora from '@/views/Aozora'
import Archive from '@/views/Archive'
import PrivacyPolicy from '@/views/PrivacyPolicy'
// Vuexと同様で最初にプラグインとして登録
Vue.use(VueRouter)
// VueRouterインスタンスを生成する
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
       return savedPosition
    } else {
       return { x: 0, y: 0 }
    }
  },
  // URLのパスと紐づくコンポーネントをマッピング
  routes: [
    {
      path: '/',
      name:'top',
      component: Top
    },
    {
      path: '/WORKS/:url',
      name: 'works',
      component: Works,
      props: true
    },
    {
      path: '/project/:title',
      name: 'project',
      component: Project,
      props: true
    },
    {
      path: '/PROFILE',
      name: 'profile',
      component: Profile
    },
    {
      path: '/CONTACT',
      name: 'contact',
      component: Contact
    },
    {
      path: '/HIYAMIZU',
      name: 'hiyamizu',
      component: Hiyamizu
    },
    {
      path: '/AOZORA',
      name: 'aozora',
      component: Aozora 
    },
    {
      path: '/ARCHIVE',
      name: 'archive',
      component: Archive
    },
    {
      path: '/PRIVACYPOLICY',
      name: 'privacyPolicy',
      component: PrivacyPolicy
    },
  ]
})
// 生成したVueRouterインスタンスをエクスポート
export default router